import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export function ChangePasswordDialog({ open, onOpenChange, mandatory = false, onSuccess }) {
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setActual(""); setNueva(""); setConfirmar(""); };

  const submit = async () => {
    if (nueva.length < 8) return toast.error("La nueva contraseña debe tener al menos 8 caracteres");
    if (nueva !== confirmar) return toast.error("Las contraseñas no coinciden");
    setSaving(true);
    try {
      await api.post("/auth/cambiar-password", { password_actual: actual, password_nueva: nueva });
      toast.success("Contraseña actualizada");
      reset();
      onSuccess?.();
      if (!mandatory) onOpenChange?.(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Error al cambiar la contraseña"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={mandatory ? () => {} : onOpenChange}>
      <DialogContent
        className={`max-w-sm ${mandatory ? "[&>button]:hidden" : ""}`}
        onPointerDownOutside={(e) => mandatory && e.preventDefault()}
        onEscapeKeyDown={(e) => mandatory && e.preventDefault()}
        data-testid="change-password-dialog"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-primary" /> Cambiar contraseña</DialogTitle>
          <DialogDescription>
            {mandatory ? "Por seguridad, tenés que cambiar tu contraseña antes de continuar." : "Elegí una nueva contraseña de al menos 8 caracteres."}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Contraseña actual</Label><Input type="password" value={actual} onChange={(e) => setActual(e.target.value)} className="rounded-xl mt-1" data-testid="cp-actual" /></div>
          <div><Label>Nueva contraseña</Label><Input type="password" value={nueva} onChange={(e) => setNueva(e.target.value)} className="rounded-xl mt-1" data-testid="cp-nueva" /></div>
          <div><Label>Confirmar nueva contraseña</Label><Input type="password" value={confirmar} onChange={(e) => setConfirmar(e.target.value)} className="rounded-xl mt-1" data-testid="cp-confirmar" /></div>
        </div>
        <DialogFooter>
          {!mandatory && <Button variant="outline" className="rounded-full" onClick={() => onOpenChange(false)}>Cancelar</Button>}
          <Button onClick={submit} disabled={saving} className="rounded-full bg-primary hover:bg-primary/90" data-testid="cp-submit">{saving ? "Guardando…" : "Guardar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
